import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Renders trusted, static SVG/HTML strings (e.g. the navigation icon set) via
 * [innerHTML]. The default HTML sanitizer strips <svg>, so these author-controlled
 * markup strings are explicitly trusted. Never pass user-supplied input here.
 */
@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
